import * as React from "react";
import { LoginContainer } from "@Components/auth";

interface LoginPageProps {
  redirectTo?: string;
}

export const LoginPage: React.FC<LoginPageProps> = React.memo(({ redirectTo }) => (
  <LoginContainer redirectTo={redirectTo} />
));

export default LoginPage;
